module.exports = __webpack_public_path__ + "images/emoji/cow.e21fe2714e41b55222c7.png";